import React from 'react';
import { Image } from 'react-bootstrap';
import PropTypes from 'prop-types';

import { colorFromName } from '../utils/generatedAvatar';
const CommunityHero = ({ imageUrl, name }) => {
    const fallbackHero = () => {
        return (
            <svg
                viewBox="0 0 1200 200"
                preserveAspectRatio="xMidYMid slice"
                role="img"
                aria-label={name}
                className="w-100 community-hero-image"
            >
                <rect width="100%" height="100%" fill={colorFromName(name)} />

                <text
                    x="50%"
                    y="50%"
                    fontSize={Math.max(100 - name.length, 25)}
                    textAnchor="middle"
                    dominantBaseline="middle"
                    dy="0.05em"
                    fill="white"
                >
                    {name}
                </text>
            </svg>
        );
    };

    return (
        <div className="community-hero w-100">
            {imageUrl ? (
                <Image
                    src={imageUrl}
                    alt={name || 'Community hero image'}
                    fluid
                    className="w-100 community-hero-image"
                />
            ) : (
                fallbackHero()
            )}
        </div>
    );
};

CommunityHero.propTypes = {
    imageUrl: PropTypes.string,
    name: PropTypes.string.isRequired,
};

export default CommunityHero;
